import React from "react";
import { Link } from "react-router-dom";
import "./Project.css";
const Project = (props) => {
  const {
      id,
    name,
    img,
    tech1,
    tech2,
    tech3,
    tech4,
    tech5,
    tech6,
    tech7,
    tech8,
    tech9,
    liveSite,
    clientSide,
    serverSide,
  } = props?.project;

  return (
    <div className="col-lg-4 col-md-6 col-12 ">
      <div className="project">
        <div className=" card">
          <img className="card-img-top" src={img} alt="" />
          <h2 className="project-name text-center">{name}</h2>

          <div className=" card-body">
            <h4 className="fw-bold">Technologies :</h4>
            <p className="btn card-btn">{tech1}</p>
            <p className="btn card-btn">{tech2}</p>
            <p className="btn card-btn">{tech3}</p>
            <p className="btn card-btn">{tech4}</p>
            <p className="btn card-btn">{tech5}</p>
            <p className="btn card-btn">{tech6}</p>
            <p className="btn card-btn">{tech7}</p>
            <p className="btn card-btn">{tech8}</p>
            <p className="btn card-btn">{tech9}</p>
            <div className="mt-4 ms-4">
              <Link to={`/project/${id}`}className="btn card-btn text-center mt-2  ms-4 " >Details</Link>
              <a
                href={liveSite}
                target="_blank"
                rel="noreferrer"
                className="btn card-btn me-5 ms-3  "
              >
                Live-Site
              </a>
              <a
                href={clientSide}
                target="_blank"
                rel="noreferrer"
                className="btn card-btn   ms-5"
              >
                Client-Side
              </a>
              <a
                href={serverSide}
                target="_blank"
                rel="noreferrer"
                className="btn ms-0 ms-3 card-btn  "
              >
                Server-Side
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Project;
